import { Midnight } from "./colours"

/**
 * - Styles override to MuiToggleButton to match Vacasa owner onboarding design
 */
const muiToggleButton = {
    styleOverrides: {
        root: () => ({
            border: "none",
            padding: "13px 20px",
            color: Midnight[70],
            "&.MuiToggleButtonGroup-grouped:not(:last-of-type)": {
                borderTopRightRadius: "inherit",
                borderBottomRightRadius: "inherit",
            },
            "&.MuiToggleButtonGroup-grouped:not(:first-of-type)": {
                borderTopLeftRadius: "inherit",
                borderBottomLeftRadius: "inherit",
            },
            "&.Mui-selected": {
                border: "none",
                backgroundColor: Midnight[10],
                borderRadius: "50px",
                color: Midnight[100],
                "&:hover": {
                    backgroundColor: Midnight[10],
                    borderRadius: "50px",
                }
            },
            "&:hover": {
                backgroundColor: Midnight[10],
                borderRadius: "50px",
            }
        }),
    },
}

export default muiToggleButton
